import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
    loading: false,
    error: null,
    verificationData: null
};

const ReportVerificationSlice = createSlice({
    name: "reportVerification",
    initialState,
    reducers: {
        fetchVerificationData(state, action) {
            state.loading = true;
            state.error = null;
            state.verificationData = null;
        },
        fetchVerificationDataSuccess(state, action) {
            state.verificationData = action.payload.data;
            state.loading = false;
        },
        fetchVerificationDataFailure(state, action) {
            state.loading = false;
        }
    },
});

export const { actions, reducer, name: sliceKey } = ReportVerificationSlice;